import { defineQuery as p } from "bitecs";
import "../../core/ecs/components.js";
import "three";
import "../../core/validation/schemas.js";
import { InputState as i } from "./components.js";
import { cleanupEventListeners as a, clearAllInput as o, setupEventListeners as u, updateInputState as m, resetFrameDeltas as c, getFocusedCanvas as d } from "./utils.js";
import { getRenderingContext as f } from "../rendering/utils.js";
const l = p([i]), E = {
  group: "simulation",
  setup: () => {
    u(), o();
  },
  update: (t) => {
    const e = d(), n = f(t);
    if (!e || !n.canvas || n.canvas !== e)
      return;
    const r = l(t.world);
    for (const s of r)
      m(s);
    c();
  },
  dispose: () => {
    a(), o();
  }
};
export {
  E as InputSystem
};
//# sourceMappingURL=systems.js.map
